<div>
  @for (option of options; track option) {
    <div (click)="selectOption(option)"
      [attr.data-cy]="buttonDataCy(option)"
      [class]="getOptionClass(option)"
      [ngStyle]="option.inlineStyle">
      @if (option?.icon != null) {
        <ng-container *ngTemplateOutlet="option.icon; context: {option: option}"></ng-container>
      }
      <span>{{option.label}}</span>
    </div>
  }
</div>
